//
// --- Types ---

export type PersonUserFlagKeyType = keyof typeof PERSON_USER_FLAG;
export type PersonUserFlagType = typeof PERSON_USER_FLAG[PersonUserFlagKeyType];

export type PersonStatusCodeKeyType = keyof typeof PERSON_STATUS_CODE;
export type PersonStatusCodeType = typeof PERSON_STATUS_CODE[PersonStatusCodeKeyType];

export type PersonStatusCodeText = Partial<Record<PersonStatusCodeKeyType, string>>;

//
// --- Constants ---

export const PERSON_USER_FLAG = {
  BUYER: 'B',
  SUPPLIER: 'S'
} as const;

export const PERSON_STATUS_CODE = {
  ACTIVE: 'A',
  CONTACT: 'C',
  DELETED: 'D',
  INACTIVE: 'I',
  INVITED: 'V',
  PENDING: 'P',
  REQUEST: 'R',
  SUSPENDED: 'S'
} as const;

export const PERSON_STATUS_CODE_TEXT: PersonStatusCodeText = {
  INVITED: 'Not yet registered'
} as const;
